var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRespondOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEB913"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 23.000000)",
    fill: "#5C5E65",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,3 C14,4.6570603 12.6570933,6 11,6 C9.34290674,6 8,4.65709326 8,3 C8,1.34290674 9.34290674,0 11,0 C12.6570933,0 14,1.34290674 14,3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,3 C6,4.64806188 4.64777217,6 2.99935712,6 C1.35094207,6 0,4.64806188 0,3 C0,1.35193812 1.35222783,0 3.00064288,0 C4.64777217,0 6,1.35193812 6,3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0006429,6 C17.3432275,6 16,4.65709326 16,3 C16,1.34290674 17.3431945,0 19.0006429,0 C20.6567725,0 22,1.34290674 22,3 C22,4.6570603 20.6568055,6 19.0006429,6 Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespondOther);
export default __webpack_public_path__ + "static/media/respond_other.2141a8a6.svg";
export { ForwardRef as ReactComponent };